import { Reveal } from "@/components/motion";
import { motion } from "framer-motion";
import { Eye, Sparkles, Activity, Glasses, ScanEye, Crosshair, Syringe, Zap, ShieldCheck } from "lucide-react";

const services = [
  { icon: Eye, title: "Comprehensive Eye Exam", desc: "Detailed vision and ocular health assessment for all ages." },
  { icon: Sparkles, title: "Advanced Premium Phaco Cataract Surgery", desc: "Bladeless Phaco with premium IOLs for crisp, lasting vision." },
  { icon: Activity, title: "Glaucoma & Retina Management", desc: "Early detection and long-term care for sight-threatening conditions." },
  { icon: Glasses, title: "LASIK & Refractive Surgery", desc: "Precision laser vision correction for spectacle removal." },
  { icon: ScanEye, title: "Cornea Management", desc: "Diagnosis and treatment of corneal disorders and infections." },
  { icon: Crosshair, title: "Squint Correction", desc: "Eye-alignment correction for children and adults." },
  { icon: Syringe, title: "Oculoplasty Surgeries", desc: "Eyelid, tear-duct and cosmetic ophthalmic procedures." },
  { icon: Zap, title: "Keratoconus Treatment with C3R", desc: "Corneal collagen cross-linking to halt keratoconus progression." },
];

const empanelment = ["ECHS", "ESI", "PMJAY", "All Major Insurances"];

export default function Services() {
  return (
    <section id="services" className="py-24 sm:py-32 bg-[var(--bg)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-[var(--teal)] text-sm tracking-[0.25em] uppercase mb-4">What we do</p>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl tracking-tight text-[var(--ink)] max-w-2xl">
            Complete eye care, under one roof.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05} className="col-span-1 md:col-span-6 lg:col-span-3">
              <motion.div
                whileHover={{ y: -6 }}
                data-testid={`service-${i}`}
                className="h-full rounded-3xl bg-white border border-border p-8 hover:shadow-[0_20px_40px_rgb(13,122,122,0.12)] hover:border-[var(--teal)]/30 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-2xl bg-[var(--teal-light)] flex items-center justify-center text-[var(--teal)] mb-6">
                  <s.icon size={22} />
                </div>
                <h3 className="font-display text-2xl text-[var(--ink)] mb-2 leading-tight">{s.title}</h3>
                <p className="text-[var(--ink-soft)] leading-relaxed">{s.desc}</p>
              </motion.div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-6 rounded-3xl bg-[var(--teal-dark)] p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center gap-6 justify-between">
            <div className="flex items-center gap-4 text-white">
              <ShieldCheck size={28} className="text-[var(--teal-light)] shrink-0" />
              <span className="font-display text-2xl sm:text-3xl">Empanelled &amp; Cashless</span>
            </div>
            <div className="flex flex-wrap gap-3">
              {empanelment.map((d) => (
                <span key={d} data-testid={`empanel-${d.toLowerCase().replace(/\s+/g, '-')}`} className="px-4 py-2 rounded-full bg-white/10 border border-white/15 text-white text-sm">{d}</span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
